import { useParams, usePathname } from 'next/navigation';
import useTranslation from 'next-translate/useTranslation';

// Lib
import { groupHasAccess } from '@/lib/acl/pageHasAccess';

// Utils
import { formatUrls } from '@/utils/urls/formatUrl';

// Types
import type { SocialProfileNetworkType } from '@/types/socialProfileType';

// Components
import Icon from '@/components/base/Icon';
import { RegularEmptyState } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/components/RegularEmptyState';
import { SupportedNetworkTypes } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/components/SupportedNetworkTypes';
import { CreateGroupButton } from '@/components/layouts/LayoutPlatform/components/PageContentWrapper/components/CreateGroupButton';

type MultiProfilesEmptyStateProps = {
    supportedNetworkTypes: SocialProfileNetworkType[];
};

export function MultiProfilesEmptyState({ supportedNetworkTypes }: MultiProfilesEmptyStateProps) {
    const pathname = usePathname();
    const params = useParams();

    const { t } = useTranslation('layout_platform');
    const groupCanAccess = formatUrls(groupHasAccess, params).includes(pathname);

    return (
        <div data-testid="multi-profiles-empty-state" className="flex-1">
            <RegularEmptyState
                tag={
                    <div className="inline-flex gap-1">
                        <Icon icon="group" />
                        {t('empty_states.multi_profiles.tag')}
                    </div>
                }
                title={t('empty_states.multi_profiles.title')}
                description={t('empty_states.multi_profiles.description')}>
                {groupCanAccess ? (
                    <CreateGroupButton />
                ) : (
                    <SupportedNetworkTypes supportedNetworkTypes={supportedNetworkTypes} />
                )}
            </RegularEmptyState>
        </div>
    );
}
